import { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { products } from '@/mocks/products';
import { productFaqs } from '@/mocks/productFaqs';
import ProductGallery from './components/ProductGallery';
import ProductInfo from './components/ProductInfo';
import RelatedProducts from './components/RelatedProducts';
import ProductFaq from './components/ProductFaq';
import WhatsAppButton from '@/components/feature/WhatsAppButton';

const productTitles: Record<string, string> = {
  bt950: 'Máquina de Solda de Geomembrana BT950 | SoldaGeo',
  bt1600: 'Máquina de Solda de Geomembrana BT1600 | SoldaGeo',
  bt800: 'Máquina de Solda de Geomembrana BT800 | SoldaGeo',
  'cx300-1400w': 'Máquina de Solda de Geomembrana Canex CX300 | SoldaGeo',
  ex3: 'Extrusora de Geomembrana EX3 | SoldaGeo',
  wgw300: 'Máquina de Solda de Geomembrana Weldy WGW300 | SoldaGeo',
  'bt-gm1': 'Máquina de Solda de Geomembrana BT-GM1 | SoldaGeo',
  'soprador-2000w-com-rolo': 'Soprador de Ar Quente para Geomembrana 2000W | SoldaGeo',
  'extrusora-metabo-bt610a': 'Extrusora de Geomembrana Metabo BT610A | SoldaGeo',
  lc3000c: 'Máquina de Solda de Geomembrana LC3000C | SoldaGeo',
  'weldy-wgw300-plus': 'Máquina de Solda de Geomembrana Weldy WGW300 Plus | SoldaGeo',
  'extrusora-weldy-booster-ex3-plus': 'Extrusora de Geomembrana Weldy Booster EX3 Plus | SoldaGeo',
};

const productDescriptions: Record<string, string> = {
  bt950: 'Máquina de solda de geomembrana BT950 por cunha quente, com 2100W. Solda PEAD, PELBD e PVC de 0,5 a 3,0 mm, com velocidade de 5 a 8 m/min e controle digital de temperatura. Distribuidor oficial no Brasil com suporte técnico e envio para todo o país.',
  bt1600: 'Máquina de solda de geomembrana BT1600 de 1600W para projetos de médio e grande porte. Solda PEAD, PELBD e PVC de 0,4 a 2,0 mm a 5 m/min. Equipamento leve e robusto para soldagem profissional. Envio para todo o Brasil.',
  bt800: 'Máquina de solda de geomembrana BT800 compacta e leve, ideal para obras de menor escala. Com 800W, solda PEAD, PELBD e PVC de 0,5 a 1,5 mm. Fácil de transportar para locais de difícil acesso. Envio para todo o Brasil.',
  'cx300-1400w': 'Máquina de solda de geomembrana Canex CX300 por cunha quente, com 1400W e alta precisão. Solda PEAD, PELBD e PVC de 0,5 a 1,8 mm com velocidade ajustável. Distribuidor oficial no Brasil com suporte técnico.',
  ex3: 'Extrusora EX3 para soldagem de geomembrana por extrusão, com 3400W e temperatura de até 700°C. Ideal para reparos, cantos e junções em PEAD, PELBD e PVC. Produção de 3,5 kg/h. Envio para todo o Brasil.',
  wgw300: 'Máquina de solda de geomembrana Weldy WGW300 por cunha quente, com 2100W e velocidade de até 9 m/min. Alta produtividade para grandes obras de impermeabilização. Solda PEAD, PELBD e PVC de 0,5 a 3,0 mm.',
  'bt-gm1': 'Máquina de solda de geomembrana BT-GM1 com controle digital avançado e 1800W. Solda PEAD, PELBD e PVC de 0,5 a 2,0 mm com alta precisão. Novo modelo da linha SoldaGeo. Envio para todo o Brasil.',
  'soprador-2000w-com-rolo': 'Soprador de ar quente 2000W com rolo de pressão para soldagem manual de geomembrana. Acessório para reparos, cantos e detalhes em PEAD, PELBD e PVC de 0,2 a 2,0 mm. Envio para todo o Brasil.',
  'extrusora-metabo-bt610a': 'Extrusora Metabo BT610A de 3400W para soldagem de geomembrana por extrusão. Temperatura de até 600°C e fio de PEAD de 3 a 4 mm. Ideal para reparos e junções. Distribuidor oficial no Brasil.',
  lc3000c: 'Máquina de solda de geomembrana LC3000C profissional, com 1800W e alta durabilidade. Solda PEAD, PELBD e PVC de 0,4 a 1,1 mm com velocidade de 3 a 7 m/min. Envio para todo o Brasil.',
  'weldy-wgw300-plus': 'Máquina de solda de geomembrana Weldy WGW300 Plus, com 2000W e velocidade de 4 a 8 m/min. Solda PEAD, PELBD e PVC de 0,5 a 3,0 mm com controle digital. Alta produtividade em campo.',
  'extrusora-weldy-booster-ex3-plus': 'Extrusora Weldy Booster EX3 Plus de 3400W para soldagem de geomembrana por extrusão. Temperatura de até 600°C e fio de PEAD de 3 a 4 mm. Soldas de alta resistência mecânica. Envio para todo o Brasil.',
};

export default function ProdutoPage() {
  const { slug } = useParams<{ slug: string }>();
  const product = products.find((p) => p.slug === slug);
  const faqItems = slug ? productFaqs[slug] || [] : [];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });

    if (product) {
      const seoTitle = productTitles[product.slug] || `${product.name} — SoldaGeo | Máquinas de Solda Geomembrana no Brasil`;
      const seoDesc = productDescriptions[product.slug] || `${product.description} Distribuidor oficial no Brasil. Envio para todos os estados. Suporte técnico local. Solicite orçamento via WhatsApp.`;

      document.title = seoTitle;
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', seoDesc);

      // Canonical
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', `https://soldageo.com.br/produto/${product.slug}`);

      // Inject dynamic product JSON-LD schema
      const existing = document.getElementById('product-schema');
      if (existing) existing.remove();

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'product-schema';
      script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        '@id': `https://soldageo.com.br/produto/${product.slug}`,
        url: `https://soldageo.com.br/produto/${product.slug}`,
        name: product.name,
        description: product.description,
        image: product.image,
        sku: product.slug.toUpperCase(),
        brand: { '@type': 'Brand', name: 'Soldageo Importações' },
        model: product.name,
        category: product.fullSpecs.some((s) => s.label === 'Tipo de Solda') ? 'Extrusoras para Geomembrana' : 'Máquinas de Solda Geomembrana',
        additionalProperty: product.fullSpecs.map((s) => ({
          '@type': 'PropertyValue',
          name: s.label,
          value: s.value,
        })),
        offers: {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          priceCurrency: 'BRL',
          price: '0',
          url: 'https://wa.me/554891802091',
          description: 'Preço sob consulta — solicite orçamento via WhatsApp',
        },
      });
      document.head.appendChild(script);

      // BreadcrumbList Schema
      const bcExisting = document.getElementById('breadcrumb-schema');
      if (bcExisting) bcExisting.remove();
      const bcScript = document.createElement('script');
      bcScript.type = 'application/ld+json';
      bcScript.id = 'breadcrumb-schema';
      bcScript.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Início', item: 'https://soldageo.com.br/' },
          { '@type': 'ListItem', position: 2, name: 'Máquinas de Solda de Geomembrana', item: 'https://soldageo.com.br/maquinas-de-solda-de-geomembrana' },
          { '@type': 'ListItem', position: 3, name: product.name, item: `https://soldageo.com.br/produto/${product.slug}` },
        ],
      });
      document.head.appendChild(bcScript);
    }

    return () => {
      const existing = document.getElementById('product-schema');
      if (existing) existing.remove();
      const bcExisting = document.getElementById('breadcrumb-schema');
      if (bcExisting) bcExisting.remove();
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.setAttribute('href', 'https://soldageo.com.br/');
      document.title = 'Máquina de Solda Geomembrana Brasil | SoldaGeo — Distribuidor Oficial com Suporte Técnico';
    };
  }, [product, slug]);

  if (!product) {
    return <Navigate to="/" replace />;
  }

  const waLink = 'https://wa.me/554891802091';

  return (
    <main className="min-h-screen bg-white">
      {/* Top bar */}
      <div className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm font-bold cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Voltar ao site
          </Link>
          <a
            href={waLink}
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center gap-2 text-green-400 hover:text-green-300 transition-colors text-sm font-bold cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line" />
            (48) 9180-2091
          </a>
        </div>
      </div>

      {/* Breadcrumb */}
      <nav className="border-b border-gray-100" aria-label="Breadcrumb">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-3 flex items-center gap-2 text-xs text-gray-400 uppercase tracking-wide">
          <Link to="/" className="hover:text-green-500 transition-colors cursor-pointer">Início</Link>
          <i className="ri-arrow-right-s-line" />
          <Link to="/maquinas-de-solda-de-geomembrana" className="hover:text-green-500 transition-colors cursor-pointer">Máquinas</Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-gray-700" aria-current="page">{product.name}</span>
        </div>
      </nav>

      {/* Main content */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <ProductGallery images={product.images} name={product.name} badge={product.badge} />
          <ProductInfo product={product} />
        </div>
      </div>

      {/* Related products */}
      <RelatedProducts relatedSlugs={product.relatedSlugs} />

      {/* FAQ Section */}
      {faqItems.length > 0 && (
        <ProductFaq items={faqItems} productName={product.name} productSlug={product.slug} />
      )}

      <WhatsAppButton />

      {/* Footer bar */}
      <footer className="bg-gray-900 py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-gray-400 text-xs font-bold">© 2026 SoldaGeo — Todos os direitos reservados</span>
          <Link
            to="/"
            className="text-green-400 hover:text-green-300 text-xs font-black uppercase tracking-wide transition-colors cursor-pointer"
          >
            Voltar ao site principal
          </Link>
        </div>
      </footer>
    </main>
  );
}